/**
 * @param {string}   path      - The path to the value in the model
 * @param {function} transform - transformation function to transform the value to another representation
 * @param {string}   as        - Alias for the value, to be used in the template
 *                               of a DisplayableProperty. If none is provided, then {value} may be used
 *                               as default reference to the value.
 *
 * @return {DisplayablePropertyParam}
 */
export const displayablePropertyParam = ({path, transform = undefined, as = undefined} = {}) =>

  /**
   * @typedef  {Object}    DisplayablePropertyParam
   * @property {string}   path
   * @property {function} transform
   * @property {string}   as
   */
  ({
    path,
    transform,
    as,
  });
